import { render, staticRenderFns } from "./VPopover.vue?vue&type=template&id=42fdccfb&scoped=true&"
import script from "./VPopover.vue?vue&type=script&lang=js&"
export * from "./VPopover.vue?vue&type=script&lang=js&"
import style0 from "./VPopover.vue?vue&type=style&index=0&id=42fdccfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fdccfb",
  null
  
)

export default component.exports